var map = {
	"./de/lang.php": 4386,
	"./de/pdf.php": 6519,
	"./en/lang.php": 8021,
	"./en/pdf.php": 198,
	"./fr/lang.php": 5260,
	"./fr/pdf.php": 4943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9050;